import { render } from "./Pictures.vue?vue&type=template&id=c536d61e&scoped=true"
import script from "./Pictures.vue?vue&type=script&lang=js"
export * from "./Pictures.vue?vue&type=script&lang=js"

import "./Pictures.vue?vue&type=style&index=0&id=c536d61e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c536d61e"

export default script